import { useState } from "react";
import axios from "axios";

const useApiService = () => {
  const Token = localStorage.getItem("token");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleRequest = async (method, url, data = null, formData = false) => {
    setIsLoading(true);
    setError(null);

    try {
      const config = {
        method,
        url,
        data: formData ? data : JSON.stringify(data),
        headers: {
          "Content-Type": formData ? "multipart/form-data" : "application/json",
          Authorization: `Bearer ${Token}`,
        },
      };

      const response = await axios(config);
      return {
        statusCode: response?.status,
        ...response?.data,
      };
    } catch (error) {
      setError(error.response ? error.response.data : error.message);
      return {
        statusCode: error.response?.status,
        errorMessage: error.response?.data?.message || "Something went wrong",
      };
    } finally {
      setIsLoading(false);
    }
  };

  const get = async (url) => {
    return await handleRequest("GET", url);
  };

  const post = async (url, data, formData = false) => {
    return await handleRequest("POST", url, data, formData);
  };

  const put = async (url, data) => {
    return await handleRequest("PUT", url, data);
  };

  const remove = async (url) => {
    return await handleRequest("DELETE", url);
  };

  return { isLoading, error, get, post, put, remove };
};

export default useApiService;

